<app-auth-navbar></app-auth-navbar>
<div class="section-7">
  <div class="container-9 w-container">
    <div class="feature-heading">
      <div class="text-block-21">Save <span class="text-span">more.</span> Do <span class="text-span-2">more.</span></div>
      <h1 class="heading-7">Pay bills internationally</h1>
      <div class="text-block-20">With N2Xpress, you can pay for your loved ones’ expenses and bills directly including utilities, tuition fees, home deliveries, tax bills and more.</div>
    </div>
    <div class="pay-bill-demo flex-column flex-md-row">
      <div class="pay-bill-image mb-4 mb-md-0">
        <img src="assets/images/bill-banner.png" loading="lazy" alt="n2xpress - Send money across borders, the easy way." class="image-14">
        <img src="assets/images_new/pay_bills_bg_1.png" loading="lazy" alt="n2xpress - Send money across borders, the easy way." class="image-16">
      </div>
      <div class="div-block-32">
        <h1 class="heading-9">Try it now:</h1>
        <div class="form-block-2 w-form">
          <form id="email-form" name="email-form" data-name="Email Form" class="form-2 mb-0">
            <select  name="country_name" (change)="onSelectCountry($event.target.value)" class="input_figma grey-text p-3 w-100 bg-white border-0  mb-3" required ngModel>
              <option value="" default>Which country is this bill in? </option>
              <option *ngFor="let country of countries" value="{{ country.country_id }}">
                {{ country.name }}
              </option>
            </select>
            
            <select name="biller_cat" class="input_figma p-3 w-100 bg-white border-0 grey-text mb-3" (change)="onSelectCategory($event.target.value)" required >
              <option value="" default>Select a category </option>
              <option *ngFor="let category of categoriesName" value="{{ category }}">
                {{ category }}
              </option>
            </select>
            
            <select name="biller_id" class="input_figma p-3 w-100 bg-white border-0 grey-text mb-3" required ngModel>
              <option value="" default>Select a billing provider </option>
              <option *ngFor="let biller of billersNew" value="{{ biller.biller_id }}" biller-name="{{  biller.biller_name }}">
                {{ biller.biller_name }}
              </option>
            </select>
            
            
            
            <a [routerLink]="['/register']" class="button-2 w-button primary-btn shadow-new">Get started</a>
          </form>
          <div class="w-form-done">
            <div>Thank you! Your submission has been received!</div>
          </div>
          <div class="w-form-fail">
            <div>Oops! Something went wrong while submitting the form.</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="currencies-section">
  <div class="currency-container w-container">
    <div class="currency-header"><img src="assets/images_new/Logo.svg" loading="lazy" alt="n2xpress - Send money across borders, the easy way." class="image-2 mb-0">
      <div class="section-header-text" style="color:#2371D3">Pay bills, or send <br />gifts and gestures</div>
    </div>
    <div class="currency-intro-copy">
      <div class="row">
        <div class="col-md-6 col-12">
          <p class="sm-16 secondary-text">Paying bills is a great way to send love and care to those who matter most. Rely on N2Xpress to send payments across the world to help you pay for your loved ones’ daily expenses and necessities.</p>
        </div>
        <div class="col-md-6 col-12">
          <p class="sm-16 secondary-text ">Easily keep household services running and pay for utilities, invest in education and pay for tuition fees, purchase groceries for home delivery and so much more. </p>
        </div>
      </div>
    </div>
  </div>
</div>
<h3 class="text-success text-center sm-16 my-3 px-5">N2Xpress is there for you so you can be there for them.</h3>
<div class="benefits-section-bills">
  <div class="benefits-container w-container">
    <div class="benefit-2">
      <div class="benefit-header">
        <div class="text-block-23 text-center text-md-left">1</div>
      </div>
      <div class="benefit-text">
        <div class="text-block-22 text-center text-md-left">Create your free account</div>
        <div class="row">
          <p class="sm-14 secondary-text intro-copy-text text-center text-md-left">Register online, enter your personal details. Already have an account? <a routerLink="/signin">Sign in</a> to start your transaction.</p>
        </div>
      </div>
    </div>
    <div class="benefit-1">
      <div class="benefit-header">
        <div class="text-block-23 text-center text-md-left">2</div>
      </div>
      <div class="benefit-text">
        <div class="text-block-22 text-center text-md-left">Choose options</div>
        <div class="row">
          <p class="sm-14 secondary-text intro-copy-text text-center text-md-left mt-4 w-100">Select country and bill type.</p>
        </div>
      </div>
    </div>
    
    <div class="benefit-3">
      <div class="benefit-header">
        <div class="text-block-23 text-center text-md-left">3</div>
      </div>
      <div class="benefit-text">
        <div class="text-block-22 text-center text-md-left">Input details</div>
        <div class="row">
          <p class="sm-14 secondary-text intro-copy-text text-center text-md-left mt-4">Enter billing account information and specify the amount you want to pay. </p>
        </div>
      </div>
    </div>
    <div class="benefit-4">
      <div class="benefit-header">
        <div class="text-block-23 text-center text-md-left text-success">4</div>
      </div>
      <div class="benefit-text">
        <div class="text-block-22 text-center text-md-left text-success">Confirm and send</div>
        <div class="row">
          <p class="sm-14 secondary-text intro-copy-text text-center text-md-left mt-4 w-100">Pay using your preferred method.</p>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="section-8">
  <div class="w-container">
    <div class="cta-panel px-2 py-5">
      <h2 class="heading-5">Subscribe to our newsletter. </h2>
      <div class="call-out-button col-12 col-md-6 d-flex flex-column flex-md-row">
        <input type="email" placeholder="Your email address" class="p-2 mx-2 border-0 w-100 my-2" style="line-height: inherit;">
        <a [routerLink]="['/register']" class="call-out-button-instance w-button">Subscribe</a>
      </div>
    </div>
  </div>
</div>
<app-home-footer></app-home-footer>